import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';

import { JwtInterceptor } from './interceptors/jwt.interceptor';
import { RequestInterceptor } from './interceptors/request.interceptor';

@NgModule({
    imports: [
      CommonModule,
      HttpClientModule,
      MatTableModule,
    ],
    providers: [
      { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true },
      { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true }
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ]
})

export class CoreModule {}
